import { useTheme } from '@mui/material';
import { Chart as ChartJS, ChartOptions } from 'chart.js';
import { useMemo } from 'react';
import { useBlueberryDistributionByClass } from '../../scanDataApi/hooks/useBlueberryDistributionByClass';
import { useChartFeatureMeasureLabels } from './useChartLabels';

export const useBlueberryClassDistributionChart = (
  chart?: ChartJS<'bar', number[], unknown> | null,
  plugins?: ChartOptions['plugins']
) => {
  const theme = useTheme();
  // const { t } = useTranslation();
  // Get the x and y axis labels for the current chart feature and dimension
  const labelResult = useChartFeatureMeasureLabels();
  const { data, isLoading } = useBlueberryDistributionByClass();

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },

      ...plugins,
    },
    scales: {
      y: {
        beginAtZero: true,
        min: 0,
        ticks: {
          color: theme.colors.common.white,
        },
        grid: {
          display: true,
          color: theme.colors.darkTheme.grey.muted,
        },
        title: {
          display: true,
          text: labelResult ? labelResult.yLabel : '',
          color: theme.colors.common.white,
        },
      },
      x: {
        ticks: {
          color: theme.colors.common.white,
        },
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: labelResult ? labelResult.xLabel : '',
          color: theme.colors.common.white,
        },
      },
    },
    events: ['click'] as Array<keyof HTMLElementEventMap>,
  };

  const result = useMemo(
    () => ({
      data,
      options,
      isLoading,
    }),
    [data, options, isLoading]
  );

  return result;
};
